import { render, staticRenderFns } from "./roomFeeImportDetail.vue?vue&type=template&id=0cbd9c5e&scoped=true"
import script from "./roomFeeImportDetail.vue?vue&type=script&lang=js"
export * from "./roomFeeImportDetail.vue?vue&type=script&lang=js"
import style0 from "./roomFeeImportDetail.vue?vue&type=style&index=0&id=0cbd9c5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbd9c5e",
  null
  
)

export default component.exports